import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { useGrid } from '../hook';

const SelectPerpage = () => {
  const {
    perPage,
    setPerPage
  } = useGrid();
  return /*#__PURE__*/React.createElement(Dropdown, null, /*#__PURE__*/React.createElement(Dropdown.Toggle, null, perPage, " ", " ", "rows"), /*#__PURE__*/React.createElement(Dropdown.Menu, null, [10, 20, 50, 100].map(item => /*#__PURE__*/React.createElement(Dropdown.Item, {
    key: item,
    active: item === perPage,
    onClick: () => setPerPage(item)
  }, item))));
};

export default SelectPerpage;